import { IonBadge, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonImg } from '@ionic/react';
import React from 'react';

export type IntegrationCardProps = {
  /** Caminho ou import do ícone (SVG/PNG). */
  icone: string;
  /** Texto alternativo do ícone. */
  iconeAlt?: string;
  titulo: string;
  /** Categoria curta exibida como subtítulo (ex.: "Marketing", "Pagamentos"). */
  categoria: string;
  /** Descrição curta exibida no corpo do card. */
  descricao: string;
  /** Quando true, exibe badge "Ativo" e botão muda para "Configurar". */
  ativo?: boolean;
  /** Callback principal (Ativar / Configurar). */
  onAtivar?: () => void;
  /** Quando definido, exibe um segundo botão "Detalhes". */
  onDetalhes?: () => void;
  /** Tamanho da coluna no grid (default 12/6/6). */
  size?: string;
  sizeMd?: string;
  sizeLg?: string;
};

/**
 * Card reutilizável para integrações do painel.
 * Mantém o mesmo padrão visual dos cards hardcoded em Integracoes.tsx, mas
 * permite reutilização para novas integrações (Marketing, futuras).
 */
const IntegrationCard: React.FC<IntegrationCardProps> = ({
  icone,
  iconeAlt,
  titulo,
  categoria,
  descricao,
  ativo,
  onAtivar,
  onDetalhes,
  size = '12',
  sizeMd = '6',
  sizeLg = '6',
}) => {
  return (
    <IonCol size={size} sizeMd={sizeMd} sizeLg={sizeLg}>
      <IonCard
        style={{
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <IonCardHeader style={{ flex: '0 0 auto', position: 'relative' }}>
          {ativo && (
            <IonBadge
              color="success"
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              Ativo
            </IonBadge>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '10px',
            }}
          >
            <IonImg
              src={icone}
              alt={iconeAlt || titulo}
              style={{ width: '80px', height: '80px' }}
            />
          </div>
          <IonCardTitle>{titulo}</IonCardTitle>
          <IonCardSubtitle>{categoria}</IonCardSubtitle>
        </IonCardHeader>

        <IonCardContent
          style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <p style={{ marginBottom: '20px' }}>{descricao}</p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              marginTop: 'auto',
              paddingTop: '10px',
            }}
          >
            {onAtivar && (
              <IonButton size="large" onClick={onAtivar}>
                {ativo ? 'Configurar' : 'Ativar'}
              </IonButton>
            )}
            {onDetalhes && (
              <IonButton size="large" fill="outline" onClick={onDetalhes}>
                Detalhes
              </IonButton>
            )}
          </div>
        </IonCardContent>
      </IonCard>
    </IonCol>
  );
};

export default IntegrationCard;
